// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__VNj2t","header":"ClearentDisclaimer_header__2nTvm","inner":"ClearentDisclaimer_inner__1CF9N"};